import { Component, OnInit, HostListener, Input, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FileExplorerservice } from './file-explorer.service';
import { ActivatedRoute } from '@angular/router';
import { FileNode, Archivo } from './FileNode.model';
import { AuthenticationService } from '../core/service/auth.service';
import { DomSanitizer, SafeUrl, SafeResourceUrl } from '@angular/platform-browser';
import { HttpResponse, HttpEventType } from '@angular/common/http';
import { NotificationsService } from '../core/service/notifications.service';
import { environment } from 'src/environments/environment';
import urlJoin from 'url-join';
import { formatDateStringWithTime, getCurrentLanguage } from '../core/helpers/utils';

interface ErrorArchivo {
  archivo: string;
  mensaje: string;
}


@Component({
  selector: 'app-file-explorer',
  templateUrl: './file-explorer.component.html',
  styleUrls: ['./file-explorer.component.scss']
})
export class FileExplorerComponent implements OnInit {

  @Input() tipoExplorador: string | null = null;
  @ViewChild('sidebar') sidebar!: ElementRef;
  @ViewChild('folderNameInput') folderNameInput!: ElementRef;

  rootDirectory: FileNode = {
    id: '',
    nombre: '',
    hijos: [],
    id_padre: null
  };

  loaded: boolean = false;
  error: string = '';
  showModal: boolean = false;
  showConfirmDeleteModal: boolean = false;
  showRenameModal: boolean = false;
  showChangePermissionsModal: boolean = false;
  showUploadFileModal: boolean = false;

  currentDirectory: FileNode = this.rootDirectory;
  navigationHistory: FileNode[] = [];
  nodeToDelete: FileNode | null = null;
  nodeToRename: FileNode | null = null;
  nodeToChangePermissions: FileNode | null = null;

  isContextMenuOpen: boolean = false;
  contextMenuNode: FileNode | null = null;

  newFolderForm: FormGroup;
  renameFolderForm: FormGroup;
  changePermissionsForm: FormGroup;
  loggedInUser?: string = '';

  //Renombrar ficheros
  showRenameFileModal: boolean = false; // Controla la visibilidad del modal
  renameFileForm: FormGroup; // Formulario para el modal de renombrar archivo
  fileToRename: any = null; // Archivo que se está renombrando

  // Mover ficheros
  showMoveFileModal: boolean = false; // Controla la visibilidad del modal para mover archivos
  fileToMove: Archivo | null = null; // Archivo que se va a mover
  destinationFolder: FileNode | null = null; // Carpeta de destino seleccionada en el modal

  public uploadErrorMessage: string = ''; // Nueva propiedad para manejar el mensaje de error

  sortAscending: boolean = true; // Variable para controlar el orden de la ordenación

  selectedNode: FileNode | null = null;

  // Menú de i en archivos
  showTooltip: { [fileId: string]: boolean } = {};

  // Progreso de subida
  public progress = 0;
  public uploading = false;
  public uploadComplete = false;

  // Agregar variables para la previsualización de archivos
  showPreviewFileModal: boolean = false;
  previewFileUrl: SafeUrl | null = null;
  previewFileName: string = '';
  previewFileType: string = '';

  // Variables para el modal de confirmación de borrado de archivos
  showConfirmDeleteFileModal: boolean = false;
  fileToDelete: any = null; // Variable para almacenar el archivo a eliminar

  // Modal del buscador de ficheros
  showSearchModal: boolean = false;


  // Para el downloadZip
  id_expediente: string = '';

  allowedFileTypes: string = '';

  tamanioKB_total: string = '';

  allowedMimeTypes = [
    // Imágenes
    'image/jpeg',    // .jpeg, .jpg
    'image/png',     // .png
    'image/gif',     // .gif
    'image/tiff',    // .tif, .tiff
    'image/svg+xml', // .svg

    // Videos
    'video/mp4',          // .mp4
    'video/mpeg',         // .mpg, .mpeg
    'video/quicktime',    // .mov
    'video/x-msvideo',    // .avi
    'video/x-matroska',   // .mkv
    'video/webm',         // .webm
    'video/ogg',          // .ogg

    // Audio
    'audio/ogg',          // .ogg
    'audio/mpeg',         // .mp3
    'audio/wav',          // .wav
    'audio/flac',         // .flac

    // Documentos
    'application/pdf',                                               // .pdf
    'application/msword',                                             // .doc
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
    'application/rtf',                                                // .rtf
    'application/vnd.ms-excel',                                       // .xls
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
    'application/vnd.ms-powerpoint',                                  // .ppt
    'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .pptx
    'application/vnd.oasis.opendocument.text',                        // .odt
    'application/vnd.oasis.opendocument.spreadsheet',                 // .ods
    'text/csv',                                                       // .csv
    'text/plain',                                                     // .txt
    'application/json',                                               // .json
    'application/xml',                                                // .xml
    'text/html',                                                      // .html, .htm

    // Archivos comprimidos
    'application/x-7z-compressed',  // .7z
    'application/zip',              // .zip
    'application/x-rar-compressed', // .rar
    'application/gzip',             // .gz
    'application/x-tar',            // .tar

    // Correos electrónicos
    'message/rfc822',  // .eml
    'application/vnd.ms-outlook', // .msg (Outlook)
  ];



  constructor(
    private fileExplorerService: FileExplorerservice,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private authService: AuthenticationService,
    private sanitizer: DomSanitizer,
    private notificationsService: NotificationsService
  ) {
    this.newFolderForm = this.fb.group({
      nombre: ['', Validators.required],
      tipo: ['', Validators.required]
    });

    this.renameFolderForm = this.fb.group({
      nombre: ['', Validators.required]
    });

    this.changePermissionsForm = this.fb.group({
      tipo: ['', Validators.required]
    });

    this.renameFileForm = this.fb.group({
      nuevoNombre: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    if ((this.tipoExplorador === "plantilla") || (this.tipoExplorador === "expediente")) {
      const id = this.route.snapshot.paramMap.get('id');
      if (id) {
        this.id_expediente = id;
        this.fileExplorerService.getPlantillaCarpetas(id, this.tipoExplorador).subscribe(
          (data: FileNode[]) => {
            //console.log("ngOnInit", data)
            this.tamanioKB_total = this.formatSize((data[0]?.tamanioKB_total || 0) * 1024);
            this.rootDirectory = {
              id: 'root',
              nombre: 'Root',
              hijos: data
            };
            this.currentDirectory = this.rootDirectory;
            this.loaded = true;

            // Seleccionar la carpeta raíz por defecto
            if (this.rootDirectory && this.rootDirectory.hijos && this.rootDirectory.hijos.length > 0) {
              this.selectFolder(this.rootDirectory.hijos[0], new MouseEvent('click'));
            }
          },
          (error) => {
            this.error = error;
            this.loaded = false;
          }
        );
      }

      this.allowedFileTypes = this.allowedMimeTypes.join(',');
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.context-menu') && !target.closest('.context-menu-icon')) {
      this.closeContextMenu();
    }
  }

  openModal() {
    this.showModal = true;
    setTimeout(() => {
      if (this.folderNameInput) {
        this.folderNameInput.nativeElement.focus();
      }
    }, 0);
  }

  closeModal() {
    this.showModal = false;
  }

  openDeleteModal(node: FileNode) {
    this.nodeToDelete = node;
    this.showConfirmDeleteModal = true;
  }

  closeDeleteModal() {
    this.showConfirmDeleteModal = false;
    this.nodeToDelete = null;
  }

  openRenameModal(node: FileNode) {
    this.nodeToRename = node;
    this.renameFolderForm.patchValue({ nombre: node.nombre });
    this.showRenameModal = true;
  }

  closeRenameModal() {
    this.nodeToRename = null;
    this.showRenameModal = false;
  }

  openChangePermissionsModal(node: FileNode) {
    this.nodeToChangePermissions = node;
    this.changePermissionsForm.patchValue({ tipo: node.tipo });
    this.showChangePermissionsModal = true;
  }

  closeChangePermissionsModal() {
    this.nodeToChangePermissions = null;
    this.showChangePermissionsModal = false;
  }

  openUploadFileModal() {
    this.showUploadFileModal = true;
  }

  closeUploadFileModal() {
    this.showUploadFileModal = false;
  }

  expandPathToNode(node: FileNode) {
    const path = this.getPathToNode(node);
    path.forEach(n => n.expanded = true);
  }

  navigateTo(node: FileNode) {
    if (node.hijos) {
      this.navigationHistory.push(this.currentDirectory);
      this.currentDirectory = node;
      this.expandPathToNode(node);
    }
  }

  goBack() {
    const parent = this.findParentNode(this.currentDirectory, this.rootDirectory);
    if (parent) {
      this.currentDirectory = parent;
    }
  }

  toggleFolder(node: FileNode) {
    node.expanded = !node.expanded;
    if (node.id) {
      //Mueve el scroll a lo que seleccionas
      //this.scrollToElement(node.id);
    }
  }

  selectFolder(node: FileNode, event: MouseEvent) {
    event.stopPropagation();
    if (node.hijos) {
      this.currentDirectory = node;
      this.navigationHistory = this.getPathToNode(node);
      this.expandPathToNode(node);
      node.expanded = true; // Asegurar que la carpeta seleccionada se expanda
      //Mueve el scroll a lo que seleccionas
      //this.scrollToElement(node.id); // Añade esta línea para autoscroll
      //console.log("this.currentDirectory", this.currentDirectory)
    }
  }

  scrollToElement(elementId: string | undefined) {
    if (elementId) {
      const element = document.getElementById(elementId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
      }
    }
  }

  formatSize(size: number | undefined): string {
    if (size === undefined) return '';
    if (size < 1024) return `${size} B`;
    if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} KB`;
    if (size < 1024 * 1024 * 1024) return `${(size / 1024 / 1024).toFixed(2)} MB`;
    return `${(size / 1024 / 1024 / 1024).toFixed(2)} GB`;
  }

  getBreadcrumb(): { visible: FileNode[], hidden: boolean } {
    const breadcrumbParts = [];
    let node = this.currentDirectory;

    while (node !== this.rootDirectory) {
      breadcrumbParts.unshift(node);
      node = this.findParentNode(node, this.rootDirectory)!;
    }

    // Determinar el espacio disponible
    const maxChars = 60; // Espacio total disponible
    const ellipsisChars = 3; // "..." ocupa 3 caracteres
    let currentLength = 0;
    // Mostrar siempre la última carpeta y calcular cuánto queda para las demás
    const visibleBreadcrumb: FileNode[] = [];
    const lastNode = breadcrumbParts.pop(); // Última carpeta (siempre visible)
    if (lastNode) visibleBreadcrumb.unshift(lastNode);
    while (breadcrumbParts.length > 0) {
      const node = breadcrumbParts.pop()!; // Procesar desde el final hacia adelante
      const nodeLength = (node.nombre?.length || 0) + 4; // Si nombre es undefined, usa longitud 0
      if (currentLength + nodeLength + ellipsisChars <= maxChars) {
        visibleBreadcrumb.unshift(node); // Agregar al inicio si cabe
        currentLength += nodeLength;
      } else {
        break; // Salir si no cabe más
      }
    }
    // Verificar si hubo nodos ocultos
    const hidden = breadcrumbParts.length > 0;
    return { visible: visibleBreadcrumb, hidden };
  }

  navigateToBreadcrumb(node: FileNode) {
    this.currentDirectory = node;
    this.navigationHistory = this.getPathToNode(node);
  }

  findParentNode(child: FileNode, parent: FileNode): FileNode | null {
    if (!parent.hijos) return null;
    for (let node of parent.hijos) {
      if (node === child) return parent;
      const found = this.findParentNode(child, node);
      if (found) return found;
    }
    return null;
  }

  getPathToNode(node: FileNode): FileNode[] {
    const path = [];
    let currentNode: FileNode | null = node;
    while (currentNode && currentNode !== this.rootDirectory) {
      path.unshift(currentNode);
      currentNode = this.findParentNode(currentNode, this.rootDirectory);
    }
    return path;
  }

  toggleSortOrder() {
    this.sortAscending = !this.sortAscending;
    this.sortCurrentDirectory();
  }

  sortCurrentDirectory() {
    if (this.currentDirectory.hijos) {
      this.currentDirectory.hijos.sort((a, b) => {
        const nombreA = a.nombre || '';
        const nombreB = b.nombre || '';
        if (this.sortAscending) {
          return nombreA.localeCompare(nombreB);
        } else {
          return nombreB.localeCompare(nombreA);
        }
      });
    }
  }

  createNewFolder() {
    if (this.newFolderForm.valid) {
      const id = this.route.snapshot.paramMap.get('id');
      if (id) {
        const newFolder: FileNode = {
          nombre: this.newFolderForm.get('nombre')?.value,
          tipo: this.newFolderForm.get('tipo')?.value,
          id_padre: this.currentDirectory.id,
          id_plantilla: id,
          id_expediente: id,
          hijos: []
        };

        if ((this.tipoExplorador === "plantilla") || (this.tipoExplorador === "expediente")) {
          this.fileExplorerService.newPlantillaCarpeta(newFolder, this.tipoExplorador).subscribe(
            (createdFolder) => {
              if (!this.currentDirectory.hijos) {
                this.currentDirectory.hijos = [];
              }
              createdFolder.hijos = []; // Le añado hijos al directorio nuevo para que se pinte con el icono adecuado
              this.currentDirectory.hijos.push(createdFolder);
              this.updateFolderTree(createdFolder); // Solo actualizamos el árbol de la izquierda
              this.sortCurrentDirectory(); // Ordenar después de añadir la nueva carpeta
              this.newFolderForm.reset();
              this.closeModal(); // Cerrar el modal después de crear el directorio
              this.refreshDirectoryTree(); // Actualiza el árbol después de crear una nueva carpeta
            },
            (error) => {
              console.error('Error creating new folder:', error);
            }
          );
        }

      }
    }
  }

  updateFolderTree(newFolder: FileNode) {
    const updateTree = (parent: FileNode, newNode: FileNode) => {
      if (parent.id === newNode.id_padre) {
        if (!parent.hijos) {
          parent.hijos = [];
        }
        if (!parent.hijos.find(child => child.id === newNode.id)) {
          parent.hijos.push(newNode);
        }
      } else if (parent.hijos) {
        parent.hijos.forEach(child => updateTree(child, newNode));
      }
    };

    updateTree(this.rootDirectory, newFolder);
  }

  openContextMenu(node: FileNode, event: MouseEvent) {
    event.stopPropagation();
    this.isContextMenuOpen = true;
    this.contextMenuNode = node;
  }

  closeContextMenu() {
    this.isContextMenuOpen = false;
    this.contextMenuNode = null;
  }

  renameNode(node: FileNode) {
    this.openRenameModal(node);
  }

  deleteNode(node: FileNode) {
    this.openDeleteModal(node);
  }

  changePermissions(node: FileNode) {
    this.openChangePermissionsModal(node);
  }

  onFilesDropped(files: File[]) {
    const MAX_FILE_SIZE = 10737418240; // 10 GB en bytes
    const extensionesPermitidas = [
      '.jpeg', '.jpg', '.png', '.tif', '.tiff', '.svg', '.pdf', '.txt', '.rtf', '.doc', '.docx', '.odt',
      '.xls', '.xlsx', '.ods', '.csv', '.ppt', '.pptx', '.odp', '.mp4', '.avi', '.mkv', '.webm',
      '.ogg', '.mpg', '.mpeg', '.mov', '.wmv', '.mp3', '.wav', '.flac', '.zip', '.7z', '.rar',
      '.tar', '.gz', '.eml', '.msg', '.html', '.htm', '.json', '.xml'
    ];

    // Validar archivos según la extensión permitida
    const invalidFiles = files.filter(file => {
      const extension = '.' + file.name.split('.').pop()?.toLowerCase();
      return !extensionesPermitidas.includes(extension);
    });

    const oversizedFiles = files.filter(file => file.size > MAX_FILE_SIZE);

    // Validar si hay archivos con extensiones no permitidas
    if (invalidFiles.length > 0) {
      const invalidFileNames = invalidFiles.map(file => file.name).join('\n');
      this.uploadErrorMessage = `Los siguientes archivos no están permitidos:\n${invalidFileNames}`;
      return;
    }

    // Validar si hay archivos que exceden el tamaño máximo
    if (oversizedFiles.length > 0) {
      const oversizedFileNames = oversizedFiles.map(file => file.name).join('\n');
      this.uploadErrorMessage = `Los siguientes archivos exceden el tamaño máximo de 2 GB:\n${oversizedFileNames}`;
      return;
    }


    // Limpiar el mensaje de error si no hay archivos inválidos ni demasiado grandes
    this.uploadErrorMessage = '';

    if (files.length > 0) {
      this.uploading = true;
      this.uploadComplete = false;
      this.progress = 0;

      this.authService.currentUser().subscribe(user => {
        const usuario_subida = user?.id;
        const id_carpeta = this.currentDirectory.id;

        if (id_carpeta && usuario_subida) {
          this.fileExplorerService.uploadFiles(files, id_carpeta, usuario_subida).subscribe(
            event => {
              //console.log(event)
              if (event.type === HttpEventType.UploadProgress) {
                // Actualizar la barra de progreso cuando es un evento de progreso de subida
                this.progress = Math.round((100 * event.loaded!) / event.total!);
              }

              // Verificar si el evento contiene los archivos creados y errores
              if (event.archivosCreados && event.errores) {
                const archivosCreados = event.archivosCreados;
                const errores = event.errores;

                if (errores.length > 0) {
                  this.currentDirectory['archivos'] = this.currentDirectory['archivos'] || [];
                  this.currentDirectory['archivos'].push(...archivosCreados);
                  this.uploadErrorMessage = `Errores al subir algunos archivos:<br>` +
                    errores.map((e: { archivo: string, mensaje: string }) => `* ${e.archivo}: ${e.mensaje}<br>`).join('');


                  this.uploading = false;
                  this.uploadComplete = true;
                  this.refreshDirectoryTree();
                } else {
                  this.currentDirectory['archivos'] = this.currentDirectory['archivos'] || [];
                  this.currentDirectory['archivos'].push(...archivosCreados);

                  this.uploading = false;
                  this.uploadComplete = true;
                  this.closeUploadFileModal();
                  this.refreshDirectoryTree();
                }
              }
            },
            error => {
              this.uploadErrorMessage = error;
              this.uploading = false;
            }
          );
        }
      });
    }
  }











  /*
    downloadAndSaveFile(fileId: string, fileName: string): void {
      this.fileExplorerService.downloadFile(fileId).subscribe(
        blob => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        },
        error => {
          console.error('Error descargando el archivo:', error);
        }
      );
    }
      */

  downloadAndSaveFile(fileId: string, fileName: string): void {
    // Paso 1: Obtener el token de descarga
    this.fileExplorerService.getTokenDescarga(fileId).subscribe(
      (tokenDescarga) => {
        // Paso 2: Construir la URL de descarga usando el token
        const downloadUrl = urlJoin(environment.apiURL, `archivos/descargar-directo/${fileId}?token=${tokenDescarga.tokenDescarga}`);

        // Paso 3: Crear el enlace y activar la descarga
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      },
      (error) => {
        console.error('Error obteniendo el token de descarga:', error);
      }
    );
  }

  downloadAndSaveZip(id_expediente: string): void {
    // Paso 1: Obtener el token de descarga para el ZIP
    this.fileExplorerService.getTokenDescargaZip(id_expediente).subscribe(
      (tokenDescarga) => {
        // Paso 2: Construir la URL de descarga del ZIP usando el token
        const downloadUrl = urlJoin(environment.apiURL, `carpetas/descargar-zip-directo/${id_expediente}/expediente?token=${tokenDescarga.tokenDescarga}`);

        // Paso 3: Crear el enlace y activar la descarga
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = 'downloadCaso.zip'; // Nombre del archivo ZIP
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      },
      (error) => {
        console.error('Error obteniendo el token de descarga para el ZIP:', error);
      }
    );
  }

  /*
  downloadAndSaveZip(id_expediente: string): void {
    this.fileExplorerService.downloadZip(id_expediente).subscribe(
      (response: HttpResponse<Blob>) => {
        const contentDisposition = response.headers.get('content-disposition');
        console.log("response.headers", response.headers)
        let fileName = 'downloadCaso.zip'; // Nombre predeterminado si no se encuentra la cabecera

        if (contentDisposition) {
          const matches = /filename="([^"]*)"/.exec(contentDisposition);
          if (matches && matches[1]) {
            fileName = matches[1];
          }
        }

        if (response.body) {  // Asegúrate de que response.body no sea null
          const url = window.URL.createObjectURL(response.body);
          const a = document.createElement('a');
          a.href = url;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        } else {
          console.error('Error: El cuerpo de la respuesta es nulo.');
        }
      },
      error => {
        console.error('Error descargando el expediente:', error);
      }
    );
  }
    */


  // Método para abrir el modal de confirmación de borrado de archivo
  openDeleteFileModal(file: any) {
    this.fileToDelete = file;
    this.showConfirmDeleteFileModal = true;
  }

  // Método para cerrar el modal de confirmación de borrado de archivo
  closeDeleteFileModal() {
    this.showConfirmDeleteFileModal = false;
    this.fileToDelete = null;
  }

  // Método para confirmar el borrado del archivo
  confirmDeleteFile() {
    if (this.fileToDelete && this.currentDirectory && this.currentDirectory['archivos']) {
      this.fileExplorerService.deleteFile(this.fileToDelete.id).subscribe(
        () => {
          // Verifica que 'archivos' existe antes de filtrar
          if (this.currentDirectory['archivos']) {
            this.currentDirectory['archivos'] = this.currentDirectory['archivos'].filter(
              (file: any) => file.id !== this.fileToDelete.id
            );
          }
          this.closeDeleteFileModal();
          this.refreshDirectoryTree();
        },
        (error) => {
          console.error('Error al borrar el archivo:', error);
        }
      );
    }
  }



  confirmDelete() {
    if (this.nodeToDelete) {
      if ((this.tipoExplorador === "plantilla") || (this.tipoExplorador === "expediente")) {
        this.fileExplorerService.deletePlantillaCarpeta(this.nodeToDelete.id!, this.tipoExplorador).subscribe(
          () => {
            const parent = this.findParentNode(this.nodeToDelete!, this.rootDirectory);
            this.removeNodeFromTree(this.nodeToDelete!);
            if (parent) {
              this.currentDirectory = parent;
            }
            this.closeDeleteModal();
            this.refreshDirectoryTree();
          },
          (error) => {
            console.error('Error deleting folder:', error);
          }
        );
      }
    }
  }

  confirmRename() {
    if (this.renameFolderForm.valid && this.nodeToRename) {
      const newName = this.renameFolderForm.get('nombre')?.value;
      const updatedNode: FileNode = {
        ...this.nodeToRename,
        nombre: newName
      };
      if ((this.tipoExplorador === "plantilla") || (this.tipoExplorador === "expediente")) {
        this.fileExplorerService.renamePlantillaCarpeta(this.nodeToRename.id!, updatedNode, this.tipoExplorador).subscribe(
          (res) => {
            this.nodeToRename!.nombre = res.nombre;
            this.sortCurrentDirectory(); // Ordenar después de renombrar
            this.closeRenameModal();
          },
          (error) => {
            console.error('Error renaming folder:', error);
          }
        );
      }
    }
  }

  confirmChangePermissions() {
    if (this.changePermissionsForm.valid && this.nodeToChangePermissions) {
      const newType = this.changePermissionsForm.get('tipo')?.value;

      // Crear el objeto updatedNode sin la propiedad 'nombre'
      const { nombre, ...rest } = this.nodeToChangePermissions;

      const updatedNode: FileNode = {
        ...rest,
        tipo: newType
      };


      if ((this.tipoExplorador === "plantilla") || (this.tipoExplorador === "expediente")) {
        this.fileExplorerService.changePermissionsPlantillaCarpeta(this.nodeToChangePermissions.id!, updatedNode, this.tipoExplorador).subscribe(
          () => {
            this.nodeToChangePermissions!.tipo = newType;
            this.closeChangePermissionsModal();
          },
          (error) => {
            console.error('Error changing permissions:', error);
          }
        );
      }
    }
  }

  removeNodeFromTree(nodeToRemove: FileNode) {
    const removeNode = (parent: FileNode, nodeId: string): boolean => {
      if (!parent.hijos) return false;
      const index = parent.hijos.findIndex(child => child.id === nodeId);
      if (index > -1) {
        parent.hijos.splice(index, 1);
        return true;
      }
      for (let child of parent.hijos) {
        if (removeNode(child, nodeId)) {
          return true;
        }
      }
      return false;
    };

    removeNode(this.rootDirectory, nodeToRemove.id!);
  }

  getFileIcon(tipoMime: string): string {
    if (!tipoMime) {
      return 'insert_drive_file'; // Icono genérico
    }

    const mimeIconMap: { [key: string]: string } = {
      'application/pdf': 'picture_as_pdf',
      'application/msword': 'description',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'description',
      'application/vnd.ms-excel': 'grid_on',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'grid_on',
      'application/vnd.ms-powerpoint': 'slideshow',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'slideshow',
      'image/jpeg': 'image',
      'image/png': 'image',
      'image/gif': 'image',
      'text/plain': 'text_snippet',
      'text/html': 'code',
      'application/zip': 'folder_zip',
      'application/x-rar-compressed': 'folder_zip'
    };

    return mimeIconMap[tipoMime] || 'insert_drive_file'; // Icono genérico si no se encuentra el tipo MIME
  }

  getFileIconColor(tipoMime: string): string {
    if (!tipoMime) {
      return '#000'; // Negro por defecto
    }

    const mimeColorMap: { [key: string]: string } = {
      'application/pdf': '#e74c3c', // Rojo
      'application/msword': '#3498db', // Azul
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '#3498db', // Azul
      'application/vnd.ms-excel': '#2ecc71', // Verde
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '#2ecc71', // Verde
      'application/vnd.ms-powerpoint': '#e67e22', // Naranja
      'application/vnd.openxmlformats-officedocument.presentationml.presentation': '#e67e22', // Naranja
      'image/jpeg': '#f1c40f', // Amarillo
      'image/png': '#f1c40f', // Amarillo
      'image/gif': '#f1c40f', // Amarillo
      'text/plain': '#95a5a6', // Gris
      'text/html': '#e67e22', // Naranja
      'application/zip': '#9b59b6', // Morado
      'application/x-rar-compressed': '#9b59b6' // Morado
    };

    return mimeColorMap[tipoMime] || '#000'; // Negro por defecto si no se encuentra el tipo MIME
  }

  // Método para previsualizar archivo
  previewFile(fileId: string, fileName: string, fileType: string): void {
    this.fileExplorerService.downloadFileForPreview(fileId).subscribe(
      (blob) => {
        // Crear un URL temporal para el Blob que será usado en la previsualización
        const url = window.URL.createObjectURL(blob);

        // Asignar el URL de previsualización al archivo
        this.previewFileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.previewFileName = fileName;
        this.previewFileType = fileType;
        this.showPreviewFileModal = true; // Mostrar el modal de previsualización
      },
      (error) => {
        console.error('Error descargando el archivo para previsualización:', error);
      }
    );
  }



  closePreviewFileModal(): void {
    this.showPreviewFileModal = false;
    this.previewFileUrl = ''; // Reinicia la URL para evitar problemas de tipo
  }

  isImage(fileType: string): boolean {
    return fileType.startsWith('image/');
  }

  isPDF(fileType: string): boolean {
    return fileType === 'application/pdf';
  }

  isPreviewable(fileType: string): boolean {
    return this.isImage(fileType) || this.isPDF(fileType);
  }

  // Exponemos la función en la clase del componente para usarla en el HTML
  formatDateStringWithTime(date: string): string {
    return formatDateStringWithTime(date, getCurrentLanguage());
  }

  refreshDirectoryTree() {
    const currentDirectoryId = this.currentDirectory.id; // Guarda la carpeta seleccionada actualmente

    // Verificar si los valores no son nulos
    if (this.id_expediente && this.tipoExplorador && currentDirectoryId) {
      this.fileExplorerService.getPlantillaCarpetas(this.id_expediente, this.tipoExplorador).subscribe(
        (data: FileNode[]) => {
          // Actualiza el árbol con los datos obtenidos del backend
          this.rootDirectory = {
            id: 'root',
            nombre: 'Root',
            hijos: data
          };

          // Buscar y seleccionar el nodo actual para mantener la selección
          const newCurrentDirectory = this.findNodeById(currentDirectoryId, this.rootDirectory);
          if (newCurrentDirectory) {
            this.currentDirectory = newCurrentDirectory;
            this.expandPathToNode(newCurrentDirectory);
          }

          this.loaded = true; // Actualiza el estado de carga
        },
        (error) => {
          this.error = error;
          this.loaded = false;
        }
      );
    } else {
      console.error('id_expediente o tipoExplorador son nulos');
    }
  }


  // Método auxiliar para encontrar un nodo por su ID
  findNodeById(id: string, parentNode: FileNode): FileNode | null {
    if (parentNode.id === id) {
      return parentNode;
    }

    if (parentNode.hijos) {
      for (let child of parentNode.hijos) {
        const foundNode = this.findNodeById(id, child);
        if (foundNode) {
          return foundNode;
        }
      }
    }
    return null;
  }

  // Método para alternar la visibilidad del tooltip
  toggleTooltip(fileId: string, show: boolean, event?: MouseEvent): void {
    const tooltipElement = document.querySelector(`#tooltip-${fileId}`) as HTMLElement;

    if (tooltipElement) {
      if (show && event) {
        const mouseX = event.clientX;
        const mouseY = event.clientY;

        // Mostrar el tooltip y calcular la posición en función del ratón
        tooltipElement.style.visibility = 'visible';
        tooltipElement.style.left = `${mouseX + 10}px`;  // 10px a la derecha del ratón
        tooltipElement.style.top = `${mouseY + 10}px`;   // 10px debajo del ratón
      } else {
        // Ocultar el tooltip cuando no se esté sobre el icono
        tooltipElement.style.visibility = 'hidden';
      }
    }
  }


  toggleTooltipFile(fileId: string, show: boolean, event?: MouseEvent): void {
    const tooltipElement = document.querySelector(`#tooltipFile-${fileId}`) as HTMLElement;
    const textElement = event?.target as HTMLElement;

    // Muestro
    if (tooltipElement && textElement) {
      // Verificamos si el texto está truncado (ellipsis)
      const isTextTruncated = textElement.offsetWidth < textElement.scrollWidth;

      if (show && event && isTextTruncated) {
        const mouseX = event.clientX;
        const mouseY = event.clientY;

        // Mostrar el tooltip solo si el texto tiene ellipsis
        tooltipElement.style.visibility = 'visible';
        tooltipElement.style.left = `${mouseX + 10}px`;  // 10px a la derecha del ratón
        tooltipElement.style.top = `${mouseY + 10}px`;   // 10px debajo del ratón
      } else {
        // Asegurarse de ocultar el tooltip al retirar el ratón
        tooltipElement.style.visibility = 'hidden';
      }
    }

    //Oculto
    if (tooltipElement) {
      if (!(show && event)) {
        tooltipElement.style.visibility = 'hidden';
      }
    }
  }

  transformarTipo(tipo: string | null | undefined): string {
    return tipo ? tipo.replace(/_/g, ' ') : '';
  }

  getUploaderDisplay(file: any): string {
    const nombre = file?.['usuario_nombre'] ?? '';
    const apellidos = file?.['usuario_apellidos'] ?? '';
    const fullName = `${nombre} ${apellidos}`.trim();
    return this.truncateText(fullName, 22);
  }

  private truncateText(value: string, maxLength: number): string {
    if (!value) {
      return '';
    }

    if (value.length <= maxLength) {
      return value;
    }

    const ellipsis = '...';
    const sliceLength = Math.max(maxLength - ellipsis.length, 0);
    return value.slice(0, sliceLength).trimEnd() + ellipsis;
  }

  openSearchModal() {
    this.showSearchModal = true;
  }

  closeSearchModal() {
    this.showSearchModal = false;
  }

  // Método para manejar la navegación
  navigateToFolderById(folderId: string): void {
    const targetNode = this.findNodeById(folderId, this.rootDirectory); // Buscar el nodo
    console.log("targetNode ->", targetNode)
    if (targetNode) {
      this.currentDirectory = targetNode; // Seleccionar el nodo
      this.refreshDirectoryTree();
      this.closeSearchModal();
      //this.expandPathToNode(targetNode); // Expander la ruta
    }
  }

  openRenameFileModal(file: any): void {
    this.fileToRename = file;
    this.renameFileForm.patchValue({ nuevoNombre: file.nombre.split('.').slice(0, -1).join('.') }); // Quita la extensión del nombre
    this.showRenameFileModal = true;
  }
  closeRenameFileModal(): void {
    this.fileToRename = null;
    this.showRenameFileModal = false;
  }
  confirmRenameFile(): void {
    if (this.renameFileForm.valid && this.fileToRename) {
      const nuevoNombreSinExtension = this.renameFileForm.get('nuevoNombre')?.value;
      this.fileExplorerService.renameFile(this.fileToRename.id, nuevoNombreSinExtension).subscribe(
        () => {
          // Actualiza el nombre del archivo en la interfaz
          //this.fileToRename.nombre = `${nuevoNombreSinExtension}.${this.fileToRename.nombre.split('.').pop()}`;
          this.refreshDirectoryTree();
          this.closeRenameFileModal();
        },
        (error) => {
          console.error('Error renombrando el archivo:', error);
        }
      );
    }
  }

  preserveSpaces(text: string): string {
    return text.replace(/ /g, '&nbsp;');
  }

  // ================================================================
  // ================= MÉTODOS PARA MOVER ARCHIVO ===================
  // ================================================================

  /**
   * Abre el modal para mover un archivo.
   * @param file El archivo que se va a mover.
   */
  openMoveFileModal(file: Archivo): void {
    this.fileToMove = file;
    this.destinationFolder = this.currentDirectory; // Pre-selecciona la carpeta actual
    this.expandPathToNode(this.currentDirectory); // Asegura que la ruta actual esté expandida en el árbol
    this.showMoveFileModal = true;
  }

  /**
   * Cierra el modal para mover un archivo y resetea los estados.
   */
  closeMoveFileModal(): void {
    this.showMoveFileModal = false;
    this.fileToMove = null;
    this.destinationFolder = null;
  }

  /**
   * Selecciona una carpeta como destino en el modal "Mover a".
   * @param node El nodo de la carpeta seleccionada.
   * @param event El evento de clic del ratón.
   */
  selectDestinationFolder(node: FileNode, event: MouseEvent): void {
    event.stopPropagation();
    this.destinationFolder = node;
  }

  /**
   * Confirma la acción de mover el archivo a la carpeta de destino seleccionada.
   */
  confirmMoveFile(): void {
    if (!this.fileToMove || !this.destinationFolder || !this.destinationFolder.id) {
      return;
    }

    // --- ¡ACCIÓN REAL! ---
    // Se llama al servicio para mover el archivo.
    this.fileExplorerService.moveFile(this.fileToMove.id, this.destinationFolder.id).subscribe({
      next: () => {
        // La notificación de éxito ya la muestra el servicio.
        this.refreshDirectoryTree(); // Actualiza la vista para reflejar el cambio.
        this.closeMoveFileModal();   // Cierra el modal.
      },
      error: (error) => {
        // La notificación de error ya la gestiona el servicio.
        console.error('Error al mover el archivo:', error);
      }
    });
  }


}
